import React from 'react';
import { CtaButton } from './CtaButton';
import { comparison } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
const keywords = ['SESSIONS.', 'DRILLS.', 'PROGRESSIONS.', 'MANAGEMENT.'];
export function FinalCta() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="w-full bg-[#0a0a0a] px-5 py-16 text-white sm:px-8" data-id="element-71" data-mp="15d3z65b22omt">
      <div className="mx-auto w-full max-w-2xl" data-id="element-72" data-mp="1jcvc02pu5yz8">
        <h2 className="text-center text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-73" data-mp="1jbk882we4r84">
          Your next training session can keep being improvised.
          <br data-id="element-74" data-mp="1t37uzqi05k39" />
          <span className="text-[#7c3aed]" data-id="element-75" data-mp="1t1myvwg1ht3a">
            OR you can finally have a real system.
          </span>
        </h2>

        <p className="mx-auto mt-6 max-w-xl text-center text-base leading-relaxed text-neutral-400" data-id="element-76" data-mp="1o4n108tcfwn9">
          Join hundreds of coaches worldwide who already plan their entire season in under
          5 minutes.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm font-extrabold uppercase tracking-wide" data-id="element-77" data-mp="n5m7u6mvmc3z">
          {keywords.map((word, index) => <React.Fragment key={word} data-id="element-78" data-mp="s6s3ac7x8dh7" data-mpi={index}>
              {index > 0 && <li aria-hidden="true" className="text-neutral-600" data-id="element-79" data-mp="x27cgquzhl7a">
                  /
                </li>}
              <li data-id="element-80" data-mp="120sg709g2n0h">{word}</li>
            </React.Fragment>)}
          <li aria-hidden="true" className="text-neutral-600" data-id="element-81" data-mp="163oy0or5uf3d">
            /
          </li>
        </ul>
        <p className="mt-4 text-center text-sm font-extrabold uppercase tracking-wide text-[#00c853]" data-id="element-82" data-mp="1b1yvx749rtso">
          All organized.
        </p>

        <div className="mt-10 overflow-hidden rounded-xl border border-white/10" data-id="element-83" data-mp="1ktd19viwjntq">
          <table className="w-full border-collapse text-left" data-id="element-84" data-mp="1kvftmm7j1t1m">
            <thead data-id="element-85" data-mp="1ptqz6kqshhe1">
              <tr data-id="element-86" data-mp="1puaj27002fup">
                <th className="w-1/2 border-b border-r border-white/10 bg-[#141416] px-4 py-3 text-[11px] font-extrabold uppercase tracking-wider text-neutral-300" data-id="element-87" data-mp="1pqmp56qn7rfg">
                  Without Netball Ready 360
                </th>
                <th className="w-1/2 border-b border-white/10 bg-[#141416] px-4 py-3 text-center text-[11px] font-extrabold uppercase tracking-wider text-[#7c3aed]" data-id="element-88" data-mp="3lw43ldydb89e">
                  With Netball Ready 360
                </th>
              </tr>
            </thead>
            <tbody data-id="element-89" data-mp="3uufs9afobvz7">
              {comparison.map(row => <tr key={row.without} data-id="element-90" data-mp="dehkpw0ghyq5">
                  <td className="border-b border-r border-white/10 px-4 py-3 text-xs text-neutral-400" data-id="element-91" data-mp="8gockxfleun8">
                    <span aria-hidden="true" data-id="element-92" data-mp="mggx2b0j0emr">❌</span> {row.without}
                  </td>
                  <td className="border-b border-white/10 px-4 py-3 text-xs font-bold text-white" data-id="element-93" data-mp="me4jea1swqfi">
                    <span aria-hidden="true" data-id="element-94" data-mp="id16nwf1vaii">✅</span> {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-10 text-center" data-id="element-95" data-mp="2k81qoflpu29r">
          <p className="text-3xl font-extrabold tabular-nums tracking-tight text-[#7c3aed]" data-id="element-96" data-mp="2a2k2hpilucrx">
            {hours}:{minutes}:{seconds}
          </p>
          <p className="mt-1 flex items-center justify-center gap-6 text-[10px] font-bold uppercase tracking-widest text-neutral-400" data-id="element-97" data-mp="2e3dpmgo83njr">
            <span data-id="element-98" data-mp="25blhicmo8qic">HRS</span>
            <span data-id="element-99" data-mp="25as791oi7ivg">MIN</span>
            <span data-id="element-100" data-mp="25aabs79o18ol">SEC</span>
          </p>
        </div>

        <div className="relative mt-6 rounded-2xl border border-[#6d28d9] bg-[#141416] p-5" data-id="element-101" data-mp="1qekm9z59udf4">
          <span className="absolute right-0 top-0 rounded-bl-xl rounded-tr-2xl bg-[#6d28d9] px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-wider text-white" data-id="element-102" data-mp="1vd5pm7ftld7s">
            🏆 Complete package
          </span>
          <h3 className="pr-28 text-base font-extrabold sm:text-lg" data-id="element-103" data-mp="1mc7lzq9an7pq">
            🏆 NETBALL READY 360 + TACTICAL PLAYBOOK PRO
          </h3>
          <p className="mt-2 text-sm text-neutral-300" data-id="element-104" data-mp="3bsfbxac5omlu">
            6 Volumes + 5 Bonuses + Pro Tactical Kit
          </p>
          <div className="mt-5 flex items-end justify-between gap-4" data-id="element-105" data-mp="3goe5rdg96wtn">
            <div data-id="element-106" data-mp="1gnz84fqixe36">
              <p className="text-sm text-neutral-500 line-through" data-id="element-107" data-mp="1gmekzb6jgxfc">$90</p>
              <p className="text-4xl font-extrabold tracking-tight" data-id="element-108" data-mp="1bpxontp6rcr6">$27</p>
            </div>
            <span className="mb-1 rounded-full bg-[#00c853]/15 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-[#00c853]" data-id="element-109" data-mp="16p063g09kgp5">
              Save $63
            </span>
          </div>
        </div>

        <div className="mt-8" data-id="element-110" data-mp="xqxzmkxrgvuh">
          <CtaButton data-id="element-111" data-mp="sywstejd3xbu" />
        </div>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-semibold text-neutral-300" data-id="element-112" data-mp="sxven171uupw">
          <li data-id="element-113" data-mp="o03czfglru8i">🔒 Secure Payment</li>
          <li data-id="element-114" data-mp="j0qnso29eb2r">⚡ Instant Access</li>
          <li data-id="element-115" data-mp="j1s16z6qz9nn">🛡️ 7-Day Guarantee</li>
        </ul>
        <p className="mt-4 text-center text-xs font-semibold text-neutral-300" data-id="element-116" data-mp="iyw4tfajst1b">
          💳 Card · GooglePay · ApplePay
        </p>
      </div>
    </section>;
}